"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstructionCover = exports.ContentWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _vars = require("../../../styles/vars");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InstructionCover = exports.InstructionCover = _styledComponents["default"].div.withConfig({
  displayName: "styles__InstructionCover",
  componentId: "sc-1mbvacm-0"
})(["", ";background:#fff;border-radius:", "px;height:100%;overflow:hidden;position:relative;width:100%;"], (0, _vars.cardShadowCss)(false), function (p) {
  return _vars.borderRadius[p.device];
});
var ContentWrapper = exports.ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-1mbvacm-1"
})(["background:rgba(0,0,0,0.5);color:#fff;height:100%;left:0;padding:", "rem;position:absolute;top:0;width:100%;"], function (p) {
  return p.device === 'mobile' ? 1 : 2;
});
//# sourceMappingURL=styles.js.map